/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Verify_Email_Send_FailedInputs */

const en_common_sign_verify_email_send_failed = /** @type {(inputs: Common_Sign_Verify_Email_Send_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to send verification email`)
};

const zh_common_sign_verify_email_send_failed = /** @type {(inputs: Common_Sign_Verify_Email_Send_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送验证邮件失败`)
};

/**
* | output |
* | --- |
* | "Failed to send verification email" |
*
* @param {Common_Sign_Verify_Email_Send_FailedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_verify_email_send_failed = /** @type {((inputs?: Common_Sign_Verify_Email_Send_FailedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Verify_Email_Send_FailedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_verify_email_send_failed(inputs)
	return zh_common_sign_verify_email_send_failed(inputs)
});
export { common_sign_verify_email_send_failed as "common.sign.verify_email_send_failed" }